type TProps = {
  altText?: string;
  width?: number;
  height?: number;
  src: string;
};
export default function Image(props: TProps) {
  return (
    <div>
      <img
        src={props.src}
        alt={props.altText}
        width={props.width}
        height={props.height}
        style={{
          objectFit: "cover",
          maxWidth: "100%",
          height: "auto",
          display: "block",
        }}
        draggable={false}
      />
    </div>
  );
}
